module.exports = __webpack_public_path__ + "img/image16.91152872.webp";